import { render, staticRenderFns } from "./threeAsset.vue?vue&type=template&id=52b90910"
import script from "./threeAsset.vue?vue&type=script&lang=js"
export * from "./threeAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports